import { ViewOrUpdatePaymentMethodsCTA, ViewPaidInvoicesCTA } from "./ctas";
export var ManageBillToAddressIA = function ManageBillToAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getSecondaryCTA;
        return (_getSecondaryCTA = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA === void 0 ? void 0 : _getSecondaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getSecondaryCTA2, _getSecondaryCTA2$get;
        return (_getSecondaryCTA2 = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA2 === void 0 ? void 0 : (_getSecondaryCTA2$get = _getSecondaryCTA2.getLink) === null || _getSecondaryCTA2$get === void 0 ? void 0 : _getSecondaryCTA2$get.call(_getSecondaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_BILL_TO_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES(strictLocalize), TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ViewPaidInvoicesCTA(strictLocalize);
};
var getSecondaryCTA = function getSecondaryCTA(_context, strictLocalize) {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};
var MANAGE_BILL_TO_ADDRESS = function MANAGE_BILL_TO_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "RB21Bl",
    defaultMessage: [{
      "type": 0,
      "value": "Gérer l'adresse de facturation"
    }]
  });
};
var TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES = function TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "NRpOYg",
    defaultMessage: [{
      "type": 0,
      "value": "Pour modifier l'adresse de facturation, accédez à la facture que vous souhaitez modifier et choisissez « Modifier l'adresse ». Vous pouvez choisir parmi les adresses précédemment utilisées ou ajouter une nouvelle adresse à appliquer à la facture. Lorsque vous modifiez des factures payées, vous devez les traiter une par une. Les modifications apportées n'auront aucune incidence sur l'adresse de facturation associée à votre mode de paiement."
    }]
  });
};
var TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES = function TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "To1QTr",
    defaultMessage: [{
      "type": 0,
      "value": "Pour modifier l'adresse de facturation sur une facture impayée, vous devez modifier l'adresse de facturation sur le mode de paiement associé à la facture. Pour ce faire, accédez à « Modes de paiement » dans « Paramètres du compte » et recherchez le mode de paiement que vous souhaitez modifier. Sélectionnez « Modifier » à côté de l'adresse de facturation et choisissez une adresse précédemment utilisée ou ajoutez-en une nouvelle."
    }]
  });
};